import DotLoading from "../../../components/Loading/DotLoading";

function loading() {
  return <DotLoading />;
}
export default loading;
